module.exports = __webpack_public_path__ + "img/dates_mobile.ed9e9fa9.png";